import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 600 78"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M57.76 62H22.29l-5.5 14.44H2.42l29.41-75.2h11.52A7.14 7.14 0 0 1 50 5.79l27.63 70.67H63.26ZM26 50.41h28.06l-14-38ZM134.42 48.38h-13v28.08h-13.15V1.24h32.89c14.82 0 24.47 9.7 24.47 23.57 0 13.42-8.76 20.64-17.73 22.1l18.3 29.55H151Zm4.94-35.52h-18v23.91h18c7.41 0 12.8-4.74 12.8-12s-5.39-11.91-12.8-11.91ZM215.73 12.86h-22.67V8.42a7.16 7.16 0 0 1 7.14-7.17h51.34v11.61h-22.67v63.6h-13.14v-63.6ZM281.79 1.24h6a7.16 7.16 0 0 1 7.14 7.17v68h-13.14V1.24ZM325.54 38.91C325.54 15.79 342.71 0 364.27 0c15.71 0 25 7.89 30.64 16.92l-11.22 5.75a22.44 22.44 0 0 0-19.42-10.94C350 11.73 339 23.12 339 38.91s11 27.18 25.26 27.18a22.21 22.21 0 0 0 19.42-10.94l11.22 5.75c-5.72 9-14.93 16.92-30.64 16.92-21.55 0-38.72-15.82-38.72-38.91ZM432.84 1.24h6v63.61h33v11.61H425.7v-68a7.16 7.16 0 0 1 7.14-7.22ZM510 1.24h44.16v11.62H516v19.51h37.38V44H516v20.85h38.16v11.61h-51.3v-68A7.16 7.16 0 0 1 510 1.24Z",
  transform: "translate(-2.42)",
  style: {"fill":"#8a8a8d"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M589.91 59.58a9.46 9.46 0 1 1-5.81 5.83 9.48 9.48 0 0 1 5.81-5.83Z",
  transform: "translate(-2.42)",
  style: {"fill":"#f1655b"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }